import { clearAuth, getToken } from '@/utils/adminAuth'

/**
 * 本地开发默认空字符串：请求发往 devServer 同源 /api，由 vue.config.js 代理到 Flask。
 * 仅当设置 VUE_APP_API_BASE 时才直连后端（需处理 CORS）。
 */
function resolveApiBase() {
  const fromEnv = process.env.VUE_APP_API_BASE
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return String(fromEnv).replace(/\/$/, '')
  }
  return ''
}

const API_BASE = resolveApiBase()

export async function request(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  }

  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  let res
  try {
    res = await fetch(`${API_BASE}${path}`, {
      ...options,
      headers
    })
  } catch (e) {
    const hint =
      '网络请求失败。请确认 backend 已运行 python app.py；本地请用 npm run serve 并勿混用 localhost 与 127.0.0.1。'
    const err = new Error(e?.message?.includes('fetch') ? hint : e?.message || hint)
    err.cause = e
    throw err
  }

  let body = null
  const text = await res.text()
  if (text) {
    try {
      body = JSON.parse(text)
    } catch {
      body = { code: res.status, message: text }
    }
  }

  if (res.status === 401 && path !== '/api/auth/login') {
    clearAuth()
  }

  if (!res.ok) {
    const err = new Error(body?.message || res.statusText || '请求失败')
    err.code = body?.code ?? res.status
    err.status = res.status
    err.data = body
    throw err
  }

  return body
}
